import { render, staticRenderFns } from "./HospitalTable.vue?vue&type=template&id=fe668d22&scoped=true&"
import script from "./HospitalTable.vue?vue&type=script&lang=js&"
export * from "./HospitalTable.vue?vue&type=script&lang=js&"
import style0 from "./HospitalTable.vue?vue&type=style&index=0&id=fe668d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe668d22",
  null
  
)

export default component.exports